import TimerIcon from "@mui/icons-material/Timer.js";
import FormControl from "@mui/material/FormControl/index.js";
import InputLabel from "@mui/material/InputLabel/index.js";
import Select from "@mui/material/Select/index.js";
import { styled } from "@mui/material/styles";
const StyledFormControl = styled(FormControl)(({ theme }) => ({
  flex: 1,
  marginTop: theme.spacing(0.5)
}));
const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginLeft: "50px",
  "& .MuiInputLabel-asterisk": {
    order: -1,
    marginRight: theme.spacing(0.25),
    color: theme.palette.error[800]
  }
}));
const StyledSelect = styled(Select)(({ theme }) => ({
  "&&&": {
    fontFamily: "Lato",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px",
    letterSpacing: "0.5px",
    color: theme.palette.grey[800],
    paddingLeft: "12px",
    "&:before": {
      borderBottom: `1px solid ${theme.palette.grey[800]}`
    },
    "& > .MuiInputBase-input": {
      paddingLeft: "10px",
      "&:focus": {
        backgroundColor: "transparent"
      }
    }
  }
}));
const StyledTimerIcon = styled(TimerIcon)(({ theme }) => ({
  color: theme.palette.grey[800]
}));
export {
  StyledFormControl,
  StyledInputLabel,
  StyledSelect,
  StyledTimerIcon
};
